import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../routes/AuthContext";
import { toast } from "react-toastify";
import "./PaymentScreen.css";

const API_BASE = "https://deligate.vingreentech.com/api";

// "http://vinlocal.lan/veg_bags/public/api";

const PaymentScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { getCustomerData } = useContext(AuthContext);

  const customer = getCustomerData();
  const customer_id = customer?.customer_id;

  const product = location.state?.product;
  const quantity = location.state?.quantity || 1;
  const unitPrice = location.state?.unitPrice || 0; 
  // const subtotal = location.state?.totalPrice || 0;  
  const cartItems = product?.cartItems || [];

  const [addresses, setAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [loading, setLoading] = useState(false);


  /* -----------------------------
     FETCH ADDRESSES
  ----------------------------- */
  useEffect(() => {
    if (!customer_id) return;

    const fetchAddresses = async () => {
      try {
        setLoading(true);
        const formData = new FormData();
        formData.append("customer_id", customer_id);

        const res = await fetch(`${API_BASE}/customer_address_list`, {
          method: "POST",
          body: formData,
        });
        const data = await res.json();

        if (data.api_success) {
          const raw = data.data[""] || [];
          const normalized = raw.flat(Infinity);
          setAddresses(normalized);
          setSelectedAddress(normalized[0] || null);
        }
      } catch (err) {
        toast.error("Failed to load addresses");
      } finally {
        setLoading(false);
      }
    };

    fetchAddresses();
  }, [customer_id]);

  if (!product) {
    return <p className="text-center mt-5">Invalid checkout</p>;
  }

  /* -----------------------------
   SUBTOTAL & TOTAL (FIXED)
----------------------------- */
  const subtotal =
    cartItems && cartItems.length > 0
      ? cartItems.reduce((sum, item) => {
          const price = Number(item.selling_price) || 0;
          const qty = Number(item.quantity) || 0;
          return sum + price * qty;
        }, 0)
      : Number(unitPrice || 0) * Number(quantity || 1);

  const deliveryFee = subtotal > 500 ? 0 : 40;
  const total = subtotal + deliveryFee;

  /* -----------------------------
     PLACE ORDER
  ----------------------------- */
  const placeOrder = async () => {
    if (!selectedAddress) {
      toast.warning("Please select an address");
      return;
    }

    // Construct full address
    const fullAddress =
      `${selectedAddress.building_street || ""}, ${selectedAddress.door_number || ""}, ${selectedAddress.area || ""}, ${selectedAddress.city || ""}, ${selectedAddress.state || ""} - ${selectedAddress.pincode || ""}`.trim();
    const addressType = selectedAddress.customer_address_type || "Home";
    const mobileNumber = selectedAddress.contact_mobile_number || "";

    // Prepare order items
   const orderItems =
  cartItems.length > 0
    ? cartItems.map((item) => ({
        product_id: String(item.product_id),
        product_name: item.product_name,
        price: Number(item.selling_price),
        quantity: Number(item.quantity),
        uom_id: item.uom_id || null,   
        // size: "Free",
      }))
    : [
        {
          product_id: String(product.product_id || product.id || ""),
          product_name: product.product_name || product.name || "",
          price: Number(unitPrice),
          quantity: Number(quantity),
          uom_id: location.state?.uom_id || null,  
          // size: "Free",
        },
      ];

    // Prepare payload
    const payload = {
      customer_id: String(customer_id || ""),
      address: {
        type: addressType,
        full_address: fullAddress,
        mobile_number: mobileNumber,
      },
      items: orderItems,
      total_price: Number(total),
      payment_method: "Cash on Delivery",
      order_status: "Pending",
    };

    console.log("Sending Order Payload:", JSON.stringify(payload, null, 2));

    try {
      const response = await fetch(`${API_BASE}/order_placed`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      console.log("Order Response:", data);

      if (response.ok && data.api_success !== false) {
        toast.success("Order placed successfully 🎉");
        navigate("/OrderSuccess", {
          state: {
            orderDetails: {
              productImage: product.images?.[0] || product.image || "",
              productName: product.product_name || product.name || "",
              quantity: quantity,
              total,
              cashback: 0,
              address: fullAddress,
              paymentMethod: "Cash on Delivery",
            },
          },
        });
      } else {
        console.error("Order placement failed:", data);
        toast.error(
          data.message || "Order placement failed. Please try again.",
        );
      }
    } catch (error) {
      console.error("Error placing order:", error);
      toast.error("Something went wrong.");
    }
  };

  return (
    <div className="checkout-container">
      <div className="container py-4">
        <h2 className="fw-bold mb-4">Checkout</h2>

        <div className="row g-4">
          {/* LEFT SIDE */}
          <div className="col-lg-7">
            {/* ADDRESS SECTION */}
            <div className="checkout-card mb-3">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="fw-bold">Delivery Address</h5>
                {/* <button
      className="btn btn-link"
      onClick={() =>
        navigate("/account", { state: { section: "address" } })
      }
    >
      Change
    </button> */}
              </div>

              {addresses.length > 0 ? (
                addresses.map((addr) => (
                  <label
                    key={addr.customer_address_id}
                    className={`address-select-box ${
                      selectedAddress?.customer_address_id ===
                      addr.customer_address_id
                        ? "active"
                        : ""
                    }`}
                  >
                    <input
                      type="radio"
                      name="deliveryAddress"
                      checked={
                        selectedAddress?.customer_address_id ===
                        addr.customer_address_id
                      }
                      onChange={() => setSelectedAddress(addr)}
                    />

                    <div className="address-content">
                      <p className="fw-bold mb-1">
                        {addr.name} – {addr.contact_mobile_number}
                      </p>
                      <p className="mb-0">
                        {addr.building_street}, {addr.door_number}, {addr.area},{" "}
                        {addr.city}, {addr.state} - {addr.pincode}
                      </p>
                    </div>
                  </label>
                ))
              ) : (
                <p>No addresses found</p>
              )}
            </div>

            {/* PAYMENT */}
            <div className="checkout-card">
              <h5 className="fw-bold mb-3">Payment Method</h5>

              <div className="payment-methods">
                <label className="payment-box active">
                  <input type="radio" name="payment" defaultChecked />
                  <div>
                    <h6>Cash on Delivery</h6>
                    <p>Pay when your order arrives</p>
                  </div>
                </label>

                <label className="payment-box">
                  <input type="radio" name="payment" />
                  <div>
                    <h6>Online Payment</h6>
                    <p>UPI / Cards / Net Banking</p>
                  </div>
                </label>
              </div>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="col-lg-5">
            <div className="summary-card">
              <h5 className="fw-bold mb-3">Order Summary</h5>

              {cartItems.length > 0 ? (
                cartItems.map((item) => (
                  <div className="cart-item" key={item.product_id}>
                    <img
                      src={item.product_image}
                      alt={item.product_name}
                      className="item-image"
                    />

                    <div className="item-details">
                      <h6 className="item-title">{item.product_name}</h6>
                      <p className="item-qty">Qty: {item.quantity}</p>
                      <p className="item-price">
                        ₹{item.selling_price * item.quantity}
                      </p>
                    </div>
                  </div>
                ))
              ) : (
                <div className="cart-item">
                  <img
                    src={product.images?.[0]}
                    alt={product.product_name}
                    className="item-image"
                  />

                  <div className="item-details">
                    <h6 className="item-title">{product.product_name}</h6>
                    <p className="item-desc">
                      {product.product_descriptions || "Fresh quality product"}
                    </p>
                    <p className="item-qty">Qty: {quantity}</p>
                    <p className="item-price">₹{unitPrice * quantity}</p>
                  </div>
                </div>
              )}

              <hr />
              <div className="price-row">
                <span>Packaging cost</span>
                <span>₹0</span>
              </div>
              <div className="price-row">
                <span>Taxes</span>
                <span>₹0</span>
              </div>

              <div className="price-row">
                <span>Subtotal</span>
                <span>₹{subtotal}</span>
              </div>
              <div className="price-row">
                <span>Delivery</span>
                <span>{deliveryFee === 0 ? "FREE" : `₹${deliveryFee}`}</span>
              </div>
              <div className="price-row total">
                <span>Total</span>
                <span>₹{total}</span>
              </div>

              <button className="btn-place-order mt-3" onClick={placeOrder}>
                Place Order – ₹{total}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentScreen;
